import { ChannelData, ChannelPostDataParam, CreateChannelRequest, ResequenceChannelPostsParam } from '@/Interfaces/I_vod';
import { AxiosResponse } from 'axios';
import { VersionData } from '@/Interfaces/common';
import { customAxios } from '../index';

// get channel
const fetchAllChannelAPI = (): Promise<AxiosResponse<VersionData<ChannelData[]>>> =>
  customAxios.get('hktv_koc/cms/channels');

// add post to channel
const postChannelPostAPI = ({ channelId, ...data }: ChannelPostDataParam) =>
  customAxios.post(`hktv_koc/cms/channels/${channelId}`, data);

// delete post in channel
const deleteChannelPostAPI = ({ channelId, ...data }: ChannelPostDataParam) =>
  customAxios.delete(`hktv_koc/cms/channels/${channelId}`, { data });

// create channel
const createChannelAPI = (
  data: VersionData<CreateChannelRequest>,
): Promise<AxiosResponse<VersionData<ChannelData[]>>> =>
  customAxios.post('hktv_koc/cms/channels/create', data);

const updateChannelAPI = (
  data: VersionData<ChannelData[]>,
): Promise<AxiosResponse<VersionData<ChannelData[]>>> =>
  customAxios.post('hktv_koc/cms/channels/update', data);

const unpinAllChannelPostApi = (
  data: Number[]
): Promise<AxiosResponse> =>
  customAxios.post('hktv_koc/cms/channels/unpin', data);

// resequence pinned posts in a channel
const resequenceChannelPostsAPI = ({ channelId, postOrder }: ResequenceChannelPostsParam): Promise<AxiosResponse> =>
  customAxios.patch(`hktv_koc/cms/channels/${channelId}/order`, { postOrder });

export {
  fetchAllChannelAPI,
  postChannelPostAPI,
  deleteChannelPostAPI,
  createChannelAPI,
  updateChannelAPI,
  unpinAllChannelPostApi,
  resequenceChannelPostsAPI,
};
